<template>
  <v-container class="sm-view">
    <section-title title="rules.title" />
    <v-expansion-panels class="sm-view" v-model="panels">
      <v-expansion-panel
        v-for="(ruleCategory, i) in $tm('rules.list')"
        :key="i"
        :value="(i + 1) + ''"
      >
        <v-expansion-panel-title>{{ $rt(ruleCategory.category) }}</v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-list>
            <v-list-item
                v-for="(rule, j) in ruleCategory.rules"
                :key="j"
                class="mb-3"
                :variant="((targetRule - 1) === j && (i + 1) + '' === targetCategory) ? 'tonal' : 'flat'"
                ref="rulesRef"
            >
              <v-list-item-title class="color-primary">{{ j + 1 }}) {{ $rt(rule.title) }}</v-list-item-title>
              <p v-html="$rt(rule.text)"></p>
            </v-list-item>
          </v-list>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script setup>
import SectionTitle from '@/components/SectionTitle';
import { computed, nextTick, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const panels = ref([]);
const rulesRef = ref(null);

const targetCategory = computed(() => {
  return route.params.category;
});

const targetRule = computed(() => {
  return Number.parseInt(route.params.rule);
});

onMounted(() => {
  if (route.params.category) {
    panels.value = [route.params.category];
    if (targetRule.value) {
      nextTick(() => {
        if (rulesRef.value) {
          const ref = rulesRef.value[targetRule.value - 1];
          if (!ref) return;

          const el = ref.$el;
          if (el) {
            const pos = el.getBoundingClientRect().top;
            const offsetPos = pos + window.scrollY - 80;
            setTimeout(() => {
              scrollTo({
                top: offsetPos,
                behavior: 'smooth',
              });
            }, 500);
          }
        }
      });
    }
  }
});

</script>

<style scoped>

</style>
